import React from 'react';
import classNames from 'classnames';
import { useFormContext } from 'react-hook-form';
import styles from './FormTable.module.css';

function FormTableControl({ name, disabled = false, option }) {
  const { register, formState: { errors } } = useFormContext();

  const hasError = errors?.[name]?.message ? true : false;

  return (
    <input
      {...register(name, option)}
      disabled={disabled}
      className={classNames({
        [styles.inputError]: hasError
      })}
    />
  );
}

export default FormTableControl;
